<template>
    <div class="container-fluid vc-admin-companies">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">法人一覧</div>

                    <div class="card-body pt-2">
                        <div class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.group_management_tag_id"
                                            @change="onChangeSearchGroupManagementTagId"
                                            id="doctor_management_tag_id"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">管理用タグで検索</option>
                                            <option
                                                v-for="groupManagementTag in groupManagementTags"
                                                :key="`doctor_management_tag_id_${groupManagementTag.id}`"
                                                :value="groupManagementTag.id">
                                                {{ groupManagementTag.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="search.freeword"
                                            @blur="onChangeSearchFreeword"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text"
                                                @click="onChangeSearchFreeword">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 mt-md-2 mb-2 mb-md-0 ml-0 ml-md-2 text-right">
                                <button
                                    type="button"
                                    class="btn btn-yokumiru-orange"
                                    style="min-width: 100px;"
                                    @click="showModalAddGroup()">
                                    法人追加
                                </button>
                            </div>
                        </div>

                        <div :class="{ 'u-loader u-loader--p5' : !companies }">
                            <div v-if="companies">
                                <b-table
                                    :items="companies"
                                    :fields="fields"
                                    :sort-by.sync="$store.state.adminCompanies.sortBy"
                                    :sort-desc.sync="$store.state.adminCompanies.sortDesc"
                                    @sort-changed="fetchCompanies"
                                    :tbody-tr-class="rowClass"
                                    striped
                                    hover
                                    responsive
                                    class="table-bordered m-table">
                                    <template v-slot:cell(name_kana)="data">
                                        {{ data.item.name }}
                                        <div class="small">{{ data.item.name_kana }}</div>
                                        <div
                                            v-if="data.item.parent_groups.length > 0"
                                            class="small mt-1">
                                            <a :href="`/admin/organizations/${parentOrganization(data.item).id}`">
                                                <b-icon-people-fill/>
                                                <span>{{ parentOrganization(data.item).name }}</span>
                                            </a>
                                        </div>
                                    </template>

                                    <template v-slot:cell(group_management_tags.name)="data">
                                        <div class="groupManagementTagsWrapper d-flex align-items-center">
                                            <div
                                                v-for="tag in data.item.group_management_tags"
                                                class="d-flex align-baseline">
                                                <div class="groupManagementTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(representative_kana)="data">
                                        {{ data.item.representative }}
                                        <div class="small">{{ data.item.representative_kana }}</div>
                                    </template>

                                    <template v-slot:cell(full_name_kana)="data">
                                        <div v-if="data.item.authorizer">
                                            {{ data.item.authorizer.full_name }}
                                            <div class="small">{{ data.item.authorizer.full_name_kana }}</div>
                                        </div>
                                        <div v-else>
                                            <div class="text-muted">未設定</div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(is_health_package)="data">
                                        <div
                                            class="text-success"
                                            :class="{ 'text-muted' : !data.item.is_health_package }">
                                            {{ data.item.is_health_package ? '利用する' : '利用しない' }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(is_tab_consultation)="data">
                                        <div
                                            class="text-success"
                                            :class="{ 'text-muted' : !data.item.is_tab_consultation }">
                                            {{ data.item.is_tab_consultation ? '表示する' : '表示しない' }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(is_viewable_authorizer)="data">
                                        <div
                                            class="text-success"
                                            :class="{ 'text-muted' : !data.item.is_viewable_authorizer }">
                                            {{ data.item.is_viewable_authorizer ? '表示する' : '表示しない' }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(flg_paused)="data">
                                        <div :class="{ 'text-danger font-weight-bold' : data.item.flg_paused }">
                                            {{ data.item.flg_paused ? '利用停止中' : '利用中' }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(links)="data">
                                        <b-button
                                            :href="`/admin/companies/${data.item.id}`"
                                            class="btn btn-yokumiru-blue btn-sm m-2">
                                            詳細
                                        </b-button>
                                    </template>
                                </b-table>

                                <div class="d-flex flex-wrap justify-content-between align-items-center">
                                    <b-pagination
                                        :total-rows="$store.state.adminCompanies.total"
                                        :per-page="$store.state.adminCompanies.per_page"
                                        v-model="$store.state.adminCompanies.current_page"
                                        @change="fetchCompanies">
                                    </b-pagination>

                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="mr-3 mb-3">
                                            <span class="small">{{ dispPaginationDetail }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <admin-add-group-modal :group-type="groupTypeCompany"/>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import { mapMutations } from 'vuex'

    export default {
        name: 'AdminCompanies',

        data: function () {
            return {
                helper: YokumiruHelper,
                groupTypeCompany: constants.groupType.company,
                companies: null,
                groupManagementTags: [],
                isCompanyDeleted: false,
                orders: constants.orders,
                search: {
                    group_management_tag_id: null,
                    freeword: '',
                },
                sortBy: 'id',
                sortDesc: false,
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                    from: 0,
                    to: 0,
                },
                fields: [
                    {
                        'key': 'id',
                        'label': '#',
                        sortable: true,
                    },
                    {
                        'key': 'name_kana',
                        'label': '法人名',
                        sortable: true,
                    },
                    {
                        'key': 'group_management_tags.name',
                        'label': '管理用タグ',
                        sortable: false,
                    },
                    {
                        'key': 'address',
                        'label': '住所',
                        sortable: true,
                    },
                    {
                        'key': 'representative_kana',
                        'label': '代表者',
                        sortable: true,
                    },
                    {
                        'key': 'full_name_kana',
                        'label': '担当者',
                        sortable: true,
                    },
                    {
                        'key': 'tel',
                        'label': '電話番号',
                        sortable: true,
                    },
                    {
                        'key': 'user_count',
                        'label': '会員数',
                        sortable: true,
                    },
                    {
                        'key': 'is_health_package',
                        'label': '健康管理パッケージ',
                        sortable: true,
                    },
                    {
                        'key': 'is_tab_consultation',
                        'label': `${this.$locale.consultation_host}一覧タブ`,
                        sortable: true,
                    },
                    {
                        'key': 'is_viewable_authorizer',
                        'label': `${this.$locale.consultation_host}詳細`,
                        sortable: true,
                    },
                    {
                        'key': 'flg_paused',
                        'label': 'ステータス',
                        sortable: true,
                    },
                    {
                        'key': 'links',
                        'label': '',
                        'class': 'text-center',
                        sortable: false,
                    },
                ],
            }
        },

        computed: {
            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if ( this.$store.state.adminCompanies.total < 1 ) {
                    return ''
                }
                return `全${this.$store.state.adminCompanies.total}件中 ${this.$store.state.adminCompanies.from}～${this.$store.state.adminCompanies.to}件表示`
            },
        },

        created: function () {
            if (this.$route.query.deleted === '1') {
                this.isCompanyDeleted = true
            }
            this.initQueryFromState()
            this.initSearchCondition()
            this.fetchCompanies()
            this.fetchGroupManagementTags()

            bus.$on('fetch-groups', this.fetchCompanies)
        },

        mounted: function () {
            if (this.isCompanyDeleted) {
                bus.$emit('alert-success', '法人を削除しました。')
            }
        },

        beforeDestroy: function () {
            bus.$off('fetch-groups')
        },

        methods: {
            ...mapMutations({
                setQuery: 'adminCompanies/setQuery',
                setQueries: 'adminCompanies/setQueries',
                clearQueries: 'adminCompanies/clearQueries',
            }),

            /**
             * 検索条件の初期化
             */
            initQueryFromState: function () {
                if (localStorage.getItem('yokumiruWeb')) {
                    const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                    if (data.adminCompanies) {
                        this.setQueries(data.adminCompanies)
                    }
                }
            },

            /**
             * 検索条件の初期化
             */
            initSearchCondition: function () {
                this.search.group_management_tag_id = this.$store.state.adminCompanies.group_management_tag_id
                this.search.freeword = this.$store.state.adminCompanies.freeword
            },

            onChangeSearchGroupManagementTagId: async function () {
                await this.setQuery({ key: 'group_management_tag_id', value: this.search.group_management_tag_id })
                await this.fetchCompanies(1)
            },

            onChangeSearchFreeword: async function () {
                await this.setQuery({ key: 'freeword', value: this.search.freeword })
                await this.fetchCompanies(1)
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function (paginate = true) {
                let query = '?'

                const state = this.$store.state.adminCompanies

                if (paginate) {
                    query += `page=${state.current_page}`
                }
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`

                if (state.group_management_tag_id) {
                    query += `&group_management_tag_id=${state.group_management_tag_id}`
                }
                if (state.freeword && state.freeword.length > 0) {
                    query += `&freeword=${state.freeword}`
                }

                query += `&group_type=${constants.groupType.company}`

                return query
            },

            /**
             * 法人一覧取得
             *
             * @param {number|object} param
             */
            fetchCompanies: async function (param = null) {
                this.companies = null

                if (Number.isInteger(param) && param > 0) {
                    await this.setQuery({key: 'current_page', value: param})
                }
                else if (param !== null && param.hasOwnProperty('sortBy')) {
                    await this.setQuery({key: 'sortBy', value: param.sortBy})
                    await this.setQuery({key: 'sortDesc', value: param.sortDesc})
                }

                const endpoint = constants.admin.groups.endpoint.base

                axios.get(`${endpoint}${this.buildQuery()}`)
                    .then(({data}) => {
                        this.companies = data.data
                        this.setQuery({key: 'current_page', value: data.meta.current_page})
                        this.setQuery({key: 'per_page', value: data.meta.per_page})
                        this.setQuery({key: 'total', value: data.meta.total})
                        this.setQuery({key: 'from', value: data.meta.from})
                        this.setQuery({key: 'to', value: data.meta.to})
                    })
                    .catch(({response}) => {
                        this.inProgress = false
                        if (response.status === 422) {
                            this.clearQueries()
                        }
                    })
            },

            /**
             * 医師管理用タグ一覧取得
             */
            fetchGroupManagementTags: function () {
                axios.get(constants.admin.group_management_tags.endpoint.base)
                    .then(({data}) => {
                        this.groupManagementTags = data
                    })
            },

            /**
             * グループが所属する団体を返す
             * @param group
             * @return {Object|{}}
             */
            parentOrganization: function (group) {
                return this.helper.parentOrganization(group) || {}
            },

            /**
             * 追加モーダル表示
             */
            showModalAddGroup: function () {
                bus.$emit('open-modal-admin-add-group')
            },

            /**
             * テーブル行クラス
             */
            rowClass: function (item, type) {
                if (item && type === 'row') {
                    if (item.flg_paused) {
                        return 'is-invalid'
                    }
                }
                return null
            },
        },
    }
</script>

<style lang="scss" scoped>
.groupManagementTagsWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 120px;
    padding: 5px 0;
    box-sizing: border-box;

    .groupManagementTag {
        padding: 3px 5px;
        margin-right: 5px;
        color: #3461b4;
        font-size: .85em;
        background-color: #f2f4f8;
        border: 1px solid #dce4ed;
        border-radius: 2px;
    }
}
</style>

<style lang="scss">
.vc-admin-companies {
    .b-table {
        min-width: 1500px;

        th, td {
            font-size: 0.75rem;
        }
    }
}
</style>
